import CartesianChartResponse from "../cartesian/cartesian_chart_response"
import BarSeries from "./bar_series"

export default class BarChartResponse extends CartesianChartResponse {
    constructor(attributes) {
        super(attributes)
        this.bars = (attributes.bars || []).map(bar => new BarSeries(bar))
    }

    barsFor({ xAxisLabel, yAxisLabel }) {
        return this.bars.filter(bar => (
            bar.matchesAxes(xAxisLabel, yAxisLabel)
        ))
    }
}
